import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GlobalService } from './service/global.service';
import { Subject, Subscription } from 'rxjs';
import { NotificationType } from './enum/notification-type.enum';
import { AddUser } from './models/manageUsers/add-user.model';
import { AuthService } from './_services/auth.service';
import { EventBusService } from './_shared/event-bus.service';
import { AuthGaurdService } from './service/auth-gaurd.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { NotificationService } from './service/notification.service';
import { ManageUserService } from './service/manage-user.service';
import { FavPage } from './models/personnel/fav-page.model';
import { environment } from 'src/environments/environment';
import { ErrorResponseMessage } from './error-handler/error-response-message.model';
import { CustomHttpRespone } from './models/customhttpresponse/custom-http-response';
import { UserManagementModel } from './models/userManagementModel/usermang.model';
import { UserManagementService } from './service/user-management.service';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';
import { AuditLoginService } from './service/auditlogin.service';
import { SessionInitService } from './_services/session-init.service';
import { BannerConfigService } from './service/banner-config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'COMPAS';

  PROJECT_ENVI: string = environment.projectName;
  private readonly _destroying$ = new Subject<void>();

  favMenuData: UserManagementModel[] = [];
  menuSubMenuData: UserManagementModel[] = [];
  subscriptions: Subscription[] = [];


  homeMenuData: any;
  jsonDataResult: any;
  jsonSubMenuData: UserManagementModel[] = [];
  jsonPersonnelnData: any;
  menusFilter: UserManagementModel[] = [];
  show: boolean = false;
  loginUserData = new AddUser();
  url: string;
  showDeploymentAlert: boolean = false;
  bannerMessage: string = '';
  maintenanceMode: boolean = false;
  isFavourite: boolean = true;
  public favMenu = new UserManagementModel();

  loginDisplay: boolean = false;
  getUserData: AddUser;
  sup_name = 'NA';
  salesrep_id = 'NA';

  loginUser: string;
  isImpersonate: boolean = false;
  isAdmin: boolean = false;
  isHeaderAdmin: boolean = false;
  isFav: boolean = true;
  favPage = new FavPage()
  isAddToFav: boolean = true;
  isLoginCheckValidated: boolean = false;

  loggedInEmployeeId: string = "";
  loggedInNetworkId: string = "";
  loggedInEmail: string = "";

  form: any = {
    username: 'compas',
    password: '12345678'
  };

  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  roles: string[] = [];

  showAdmin = false;
  username?: string;

  eventBusSub?: Subscription;

  constructor(private router: Router,
    public http: HttpClient,
    private msalBroadcastService: MsalBroadcastService,
    private globalService: GlobalService,
    private auditLoginService: AuditLoginService,
    private authService: AuthService,
    private userManagementService: UserManagementService,
    private eventBusService: EventBusService,
    private authGaurdService: AuthGaurdService,
    private msalService: MsalService,
    private notificationService: NotificationService,
    private manageUserService: ManageUserService,
    private sessionInitService: SessionInitService,
    private bannerConfigService: BannerConfigService) {


    // Listen for route changes and save the last route
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        sessionStorage.setItem('lastRoute', event.urlAfterRedirects);
      }
    });

    globalService._disableBackButton();

    console.log("==================== APP constructor called ================");

  }

  ngOnInit(): void {
    console.log("==================== APP ngOnInit called ================");

    // Initialize session management first
    this.sessionInitService.initializeSession();

    this.msalService.instance.handleRedirectPromise()
      .then(result => {
        if (result?.account) {
          console.log("Redirect result received. Setting active account.");
          this.msalService.instance.setActiveAccount(result.account);
          this.validateLogins(); // Optional: validate after redirect
        } else {
          console.log("No redirect result. Checking existing accounts.");
          const accounts = this.msalService.instance.getAllAccounts();
          console.log(accounts);

          if (accounts.length > 0) {
            console.log("Existing account found. Setting active account.");
            this.msalService.instance.setActiveAccount(accounts[0]);
            this.validateLogins();
          } else {
            console.log("No account found. Initiating login.");
            this.login();
          }
        }
      })
      .catch(error => {
        console.error("Redirect handling failed:", error);
        // Optional: fallback login or error UI
        this.login();
      });

    // Note: loadBannerConfig() is now called in findFavMenus() after user data is loaded

    this.url = this.router.url.split('#')[0];
    this.menuSubMenuData = this.userManagementService.menuSubMenuData;
    this.favMenuData = this.userManagementService.favMenuData;
    //this.checkAndSetActiveAccount();

    this.isLoggedIn = !!this.authGaurdService.getToken();

    if (this.isLoggedIn) {
      const user = this.authGaurdService.getUser();
      this.roles = user.roles;

      this.showAdmin = this.roles.includes('ROLE_ADMIN');

      this.username = user.username;
    }

    this.setLoginDisplay();

    if (localStorage.getItem('name')) {
      this.authGaurdService.isImpersonate = true;
      this.authGaurdService.imPersonUser = localStorage.getItem('name');
    }
    this.loginUserData = this.manageUserService.loginUserData;
    //console.log("this.loginUserData = "+JSON.stringify(this.loginUserData));
    this.url = this.router.url.split('#')[0];
    // console.log(this.url);

    if (this.url === '/home' || this.url === '/help') {
      this.isAddToFav = false;
    } else {
      this.isAddToFav = true;
    }

    if (this.authGaurdService.imPersonUser) {
      this.loginUser = this.authGaurdService.imPersonUser;
    } else {
      this.loginUser = JSON.parse(localStorage.getItem('USERNAME_SESSION'));
    }

    this.isFavourite = this.authGaurdService.isFavourite;
    this.isImpersonate = this.authGaurdService.isImpersonate;

    if (this.isImpersonate) {
      this.isAddToFav = false;
    }

    if (!this.authGaurdService.imPersonUser) {
    } else {
      if (localStorage.getItem('loginUserObj')) {
        this.loginUserData = JSON.parse(localStorage.getItem('loginUserObj'));
        //console.log("this.loginUserData = "+JSON.stringify(this.loginUserData));
      }
      else {
      }
    }

    this.userManagementService.menuList$.subscribe(menuData => {
      if (menuData) {
        this.menuSubMenuData = menuData;
        this.findFavPageDetails();
        localStorage.setItem('menulist', JSON.stringify(this.menuSubMenuData));
        this.userManagementService.menuSubMenuData = this.menuSubMenuData;
        this.filterMenus(this.menuSubMenuData);
      }
    })

  }



  debugClick() {
    console.log("Dropdown clicked");
  }

  login(): void {
    console.log("login() called");
    const accounts = this.msalService.instance.getAllAccounts();
    console.log(accounts);
    console.log(accounts.length);
    if (accounts.length === 0) {
      console.log("Inside IF");
      this.msalService.instance.loginRedirect({
        scopes: ['user.read'] // or your custom scopes
      });
    } else {
      console.log("Inside ELSE");
      this.msalService.instance.setActiveAccount(accounts[0]);
      this.validateLogins(); // Optional: if you want to re-validate
    }
  }

  setLoginDisplay() {
    // console.log("setLoginDisplay called");
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
    //console.log(this.loginDisplay);
  }

  checkAndSetActiveAccount() {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        let activeAccount = this.msalService.instance.getActiveAccount();
        //console.log("activeAccount = " + JSON.stringify(activeAccount));
        if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
          let accounts = this.msalService.instance.getAllAccounts();
          this.msalService.instance.setActiveAccount(accounts[0]);
          this.authGaurdService.loginUserName = this.msalService.instance.getActiveAccount().name;
        }

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

loadBannerConfig(): void {
  // Get user's sales channel from loginUserData or localStorage
  let userSalesChannel = null;
  let userRole = null;
  
  if (this.loginUserData && this.loginUserData.sales_rep_channel) {
    userSalesChannel = this.loginUserData.sales_rep_channel;
  } else if (localStorage.getItem('loginUserObj')) {
    try {
      const userData = JSON.parse(localStorage.getItem('loginUserObj'));
      userSalesChannel = userData.sales_rep_channel;
    } catch (e) {
      console.log('Error parsing loginUserObj:', e);
    }
  }
  
  // Get user role from localStorage or authGaurdService
  if (localStorage.getItem('CURRENT_USERROLE_SESSION')) {
    userRole = localStorage.getItem('CURRENT_USERROLE_SESSION');
  } else if (this.authGaurdService.userRole) {
    userRole = this.authGaurdService.userRole;
  } else if (this.loginUserData && this.loginUserData.userRole) {
    userRole = this.loginUserData.userRole;
  }
  
  // Pass sales channel and user role to banner service
  this.bannerConfigService.getCurrentBanner(userSalesChannel, userRole).subscribe(
    (banner) => {
      if (banner && banner.show) {
        this.showDeploymentAlert = true;
        this.bannerMessage = banner.message;
        
        // Check if blockAccess is enabled (maintenance mode)
        // BUT admins should always bypass maintenance mode
        const isAdmin = userRole && userRole.toUpperCase() === 'ADMIN';
        
        if (banner.blockAccess === true && !isAdmin) {
          this.maintenanceMode = true;
        } else {
          this.maintenanceMode = false;
        }
      } else {
        this.showDeploymentAlert = false;
        this.bannerMessage = '';
        this.maintenanceMode = false;
      }
    },
    (error) => {
      console.error('Error loading banner:', error);
      this.showDeploymentAlert = false;
      this.bannerMessage = '';
      this.maintenanceMode = false;
    }
  );
}

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }


  logout() {
    console.log("logout called");
    // Clear application-specific data
    this.clearApplicationData();
    this.isLoggedIn = false;
    this.roles = [];
    this.showAdmin = false;

    // Use logoutRedirect with specific account to avoid affecting other Microsoft apps
    this.msalService.logoutRedirect({
      account: this.msalService.instance.getActiveAccount(),
      postLogoutRedirectUri: window.location.origin
    });
  }

  private clearApplicationData(): void {
    // Clear application-specific tokens and session data using session init service
    this.sessionInitService.clearApplicationSession();
    this.authGaurdService.isFavourite = true;
  }

  //   validateLogins() {
  //   const empId = this.authGaurdService.loginEmployeeId();
  //   const netId = this.authGaurdService.loginNetworkId();
  //   const email = this.authGaurdService.loginEmail();

  //   this.loggedInEmployeeId = empId ? empId.toLowerCase() : '';
  //   this.loggedInNetworkId = netId ? netId.toLowerCase() : '';
  //   this.loggedInEmail = email ? email.toLowerCase() : '';

  //   // Call service
  //   this.manageUserService.validateCredentials(
  //     this.loggedInEmployeeId,
  //     this.loggedInNetworkId,
  //     this.loggedInEmail
  //   ).subscribe({
  //     next: (response: AddUser[]) => {
  //       if (response.length > 0) {
  //         this.isLoginCheckValidated = true;
  //         if (this.loggedInEmployeeId !== "undefined") {
  //           this.filterUser(this.loggedInEmployeeId);
  //         }
  //       } else {
  //         this.isLoginCheckValidated = false;
  //         this.router.navigate(['/errorauthfailed']);
  //       }
  //     },
  //     error: (errorResponse: HttpErrorResponse) => {
  //       const msg = errorResponse?.message || 'Login validation failed';
  //       this.notificationService.sendNotification(NotificationType.ERROR, msg);
  //     }
  //   });
  // }

  validateLogins() {
    this.loggedInEmployeeId = this.authGaurdService.loginEmployeeId().toLowerCase() || '';
    this.loggedInNetworkId = this.authGaurdService.loginNetworkId().toLowerCase() || '';
    this.loggedInEmail = this.authGaurdService.loginEmail().toLowerCase() || '';

    this.manageUserService.validateCredentials(this.loggedInEmployeeId, this.loggedInNetworkId, this.loggedInEmail)
      .subscribe((response: AddUser[]) => {
        if (response.length > 0) {
          this.isLoginCheckValidated = true;
          if (this.authGaurdService.loginEmployeeId() !== "undefined") {
            this.filterUser(this.authGaurdService.loginEmployeeId());
          }
        } else {
          this.isLoginCheckValidated = false;
          this.router.navigate(['/errorauthfailed']);
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });

  }

  filterUser(empId: string) {
    this.manageUserService.filterByEmpId(empId)
      .subscribe((data: AddUser[]) => {
        this.loginUserData = data[0];
        this.authGaurdService.userRole = this.loginUserData.userRole;

        this.manageUserService.loginUserData = this.loginUserData;
        this.findFavMenus(empId);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getMultiProfileCount(empId: string) {
    this.manageUserService.getMultiProfileCount(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION'))
      .subscribe((data: any) => {

        if (data === 0) {
          localStorage.setItem('MULTIPLE_PROFILE_STATUS', "NO");
        } else {
          localStorage.setItem('MULTIPLE_PROFILE_STATUS', "YES");
        }


      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getLoginUserData() {

    this.manageUserService.filterByEmpIdByRole(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION'), localStorage.getItem('CURRENT_USERROLE_SESSION'))
      .subscribe((response: AddUser[]) => {
        this.getUserData = response[0];
        this.sup_name = this.getUserData.supervisor_name;
        this.salesrep_id = this.getUserData.sales_rep_id;



        this.localLoginSubmit();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  localLoginSubmit(): void {

    if (this.authGaurdService.getToken()) {
    } else {
      this.generateToken();
    }

  }

  generateToken() {

    const { username, password } = this.form;
    this.authService.login(this.authGaurdService.loginNetworkId()?.toLowerCase() || '', password).subscribe(
      data => {
        this.authGaurdService.saveToken(data.accessToken);
        this.authGaurdService.saveUser(data);


        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.authGaurdService.getUser().roles;


      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, 'Authorization Failed');
        this.isLoginFailed = true;
      }
    );
  }

  reloadPage(): void {
    window.location.reload();
  }

  redirect(url: string) {
    // console.log("redirect called");
    localStorage.removeItem('token');
    this.authGaurdService.isFavourite = true;
    this.router.navigate(['/' + url]);
  }


  openCurrentPageInNewTab() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([this.router.url])
    );
    window.open(url, '_blank');
  }


  // dupliSessionPage() {
  //   let url = '';
  //   if (environment.apiUrl === 'https://compas-uat-backend-exfhn7j3kq-ue.a.run.app/api/salescomm/') {
  //     window.open('https://compas-uat-frontend-exfhn7j3kq-ue.a.run.app/home', '_blank');
  //   } else if (environment.apiUrl === 'https://salescommissionrebuildbackend1-exfhn7j3kq-ue.a.run.app/api/salescomm/') {
  //     window.open('https://salescommissionrebuildfrontend-exfhn7j3kq-ue.a.run.app/home', '_blank');
  //   } else if (environment.apiUrl === 'https://compas-prod-backend-sf3kqgr7va-ue.a.run.app/api/salescomm/') {
  //     window.open('https://compas-prod-frontend-sf3kqgr7va-ue.a.run.app/home', '_blank');
  //   } else {
  //     window.open('http://localhost:4200/', '_blank');
  //   }
  // }

  endImperson() {
    this.isImpersonate = false;
    this.isAddToFav = true;
    this.loginUser = this.msalService.instance.getActiveAccount().name;
    this.userManagementService.menuSubMenuData = this.authGaurdService.menuSubMenuData;
    localStorage.removeItem('name');
    localStorage.removeItem('loginUserObj');
    localStorage.removeItem('IMPERSON_ROLE_SESSION');
    localStorage.removeItem('imperloggedInEmployeeId');
    this.router.navigate(['/'])
      .then(() => {
        window.location.reload();
      });
  }

  addToFav() {
    this.favPage.page_id = this.authGaurdService.favData.id;
    this.favPage.created_dt = new Date();
    if (this.isImpersonate) {
      this.favPage.employee_id = this.manageUserService.loginUserData.employeeId
      this.favPage.created_by = this.manageUserService.loginUserData.first_name
    }
    else {
      this.favPage.employee_id = this.authGaurdService.loginEmployeeId();
      this.favPage.created_by = this.authGaurdService.loginUser();
    }

    this.manageUserService.addMenuToFav(this.favPage)
      .subscribe(response => {
        response = response as ErrorResponseMessage;
        this.notificationService.notify(NotificationType.SUCCESS, this.authGaurdService.favData.nav_page_name + ` Added To Favourites Successfully`);
        window.location.reload();
      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
  }

  removeFromFav() {
    this.manageUserService.deleteFavpage(this.authGaurdService.favData.id,
      this.authGaurdService.loginEmployeeId()).subscribe(
        (response: CustomHttpRespone) => {
          this.notificationService.sendNotification(NotificationType.SUCCESS, this.authGaurdService.favData.nav_page_name + ' Page Removed From Favourites');
          window.location.reload();
        },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
  }




  findFavMenus(EmpId: string) {
    //console.log("Side menu findFavMenus called");
    this.userManagementService.getFavMenus(EmpId)
      .subscribe((data: UserManagementModel[]) => {
        this.favMenuData = data;

        this.userManagementService.favMenuData = this.favMenuData;

        // console.log(this.loginUserData.userRole);

        localStorage.setItem('USERROLE_SESSION', this.loginUserData.userRole);

        // console.log(JSON.parse(localStorage.getItem('IMPERSON_ROLE_SESSION')));

        if (JSON.parse(localStorage.getItem('IMPERSON_ROLE_SESSION')) === null) {
          // console.log("Inside IF");
          localStorage.setItem('CURRENT_USERROLE_SESSION', this.loginUserData.userRole);
          localStorage.setItem('CURRENT_EMPLOYEEID_SESSION', JSON.parse(localStorage.getItem('EMPLOYEEID_SESSION')));
          localStorage.setItem('CURRENT_USER_NAME_SESSION', this.authGaurdService.loginUser());
        } else {
          // console.log("Inside ELSE");
          localStorage.setItem('CURRENT_USERROLE_SESSION', JSON.parse(localStorage.getItem('IMPERSON_ROLE_SESSION')));
          localStorage.setItem('CURRENT_EMPLOYEEID_SESSION', localStorage.getItem('imperloggedInEmployeeId'));
          localStorage.setItem('CURRENT_USER_NAME_SESSION', this.authGaurdService.imPersonUser);
        }

        //  console.log("CURRENT_USERROLE_SESSION = " + localStorage.getItem('CURRENT_USERROLE_SESSION'));
        //  console.log("CURRENT_EMPLOYEEID_SESSION = " + localStorage.getItem('CURRENT_EMPLOYEEID_SESSION'));
        //  console.log("CURRENT_USER_NAME_SESSION = " + localStorage.getItem('CURRENT_USER_NAME_SESSION'));

        this.loginUser = localStorage.getItem('CURRENT_USER_NAME_SESSION');
        // console.log(this.loginUser);



        // console.log(localStorage.getItem('CURRENT_USERROLE_SESSION'));
        if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "ADMIN") {
          // console.log("Inside IF");
          this.isAdmin = true;
        } else {
          // console.log("Inside ELSE");
          // console.log(localStorage.getItem('imperloggedInEmployeeId'));
          if (localStorage.getItem('imperloggedInEmployeeId')) {
            this.isAdmin = true;
          } else {
            this.isAdmin = false;
          }

        }

        this.getLoginUserData();
        this.submitLogins();

        var result = ""
        if (localStorage.getItem('IMPERSON_ROLE_SESSION') !== null) {
          result = JSON.parse(localStorage.getItem('IMPERSON_ROLE_SESSION'));
          if (this.loginUserData.userRole === result) {
          } else {
            this.isFavMenu();
            this.getMenuList(result);

          }
        } else {
          this.isFavMenu();
          this.getMenuList(this.loginUserData.userRole);
        }

        // Restore the last route on application reload
        const lastRoute = sessionStorage.getItem('lastRoute');
        if (lastRoute === "/") {
          // console.log("APP IF");
          this.router.navigate(['/home']);
        } else if (lastRoute) {
          // console.log("APP ELSE IF");
          this.router.navigateByUrl(lastRoute);
        } else {
          // console.log("APP ELSE");
          this.router.navigate(['/home']);
        }

        console.log(localStorage.getItem('CURRENT_USERROLE_SESSION'));

        if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "ADMIN") {
          this.isHeaderAdmin = true;
        } else {
          this.isHeaderAdmin = false;
        }

        // Load banner configuration AFTER user data is populated
        this.loadBannerConfig();



      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public submitLogins(): void {
    // console.log("submitLogins() called");
    const formData = this.auditLoginService.createForm();
    this.auditLoginService.addLogins(formData).subscribe(
      (response: any) => {
        //console.log(response);
        // var statusmsg: any;
        // statusmsg = status + " Successfully";
        // this.notificationService.sendNotification(NotificationType.SUCCESS, statusmsg);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );




  }

  isFavMenu() {
    // console.log("Side menu isFavMenu called");
    this.favMenuData.forEach((menu: UserManagementModel, index: any) => {
      if (menu.nav_page_route == this.url.substring(1)) {
        this.authGaurdService.favData = menu;
        this.isFavourite = false;
      }
    });
  }

  findFavPageDetails() {
    //console.log("Side menu findFavPageDetails called");
    this.menuSubMenuData.forEach((menu: UserManagementModel, index: any) => {
      if (menu.nav_page_route == this.url.substring(1)) {
        this.authGaurdService.favData = menu;
        this.isFavourite = true;
      }
    });
  }

  getMenuList(userRole: string) {
    //console.log("Side menu getMenuList called");
    this.userManagementService.getMenuListByRole(userRole)
      .subscribe((data: UserManagementModel[]) => {
        this.menuSubMenuData = data;
        // console.log(this.menuSubMenuData);
        this.findFavPageDetails();
        localStorage.setItem('menulist', JSON.stringify(this.menuSubMenuData));
        this.userManagementService.menuSubMenuData = this.menuSubMenuData;
        this.filterMenus(this.menuSubMenuData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  filterMenus(menusData: UserManagementModel[]) {
    //console.log("Side menu filterMenus called");
    this.menusFilter = [];
    if (this.favMenuData.length > 0) {
      this.favMenu.nav_page_name = 'Favorites'
      this.favMenu.parent_page_id = 0;
      this.menusFilter.push(this.favMenu);
    }
    // console.log(menusData);
    menusData.forEach((menu: UserManagementModel, index: any) => {
      if (menu.parent_page_id == 0) {
        this.menusFilter.push(menu);
      }
    });
    //console.log(this.menusFilter);

    this.show = true;




  }

  fireEvent(subMenu: UserManagementModel) {
    this.jsonSubMenuData = [];
    if (subMenu.nav_page_name === 'Favorites') {
      this.jsonSubMenuData = this.favMenuData;
      this.authGaurdService.isFavourite = false;
    } else {
      this.authGaurdService.isFavourite = true;
      this.menuSubMenuData.forEach((menu: UserManagementModel, index: any) => {
        if (menu.parent_page_id == subMenu.id) {
          this.jsonSubMenuData.push(menu);
        }
      });
    }
    console.log(this.jsonSubMenuData);
  }

  navigateTOPage(data: UserManagementModel) {
    console.log(data.nav_page_route);
    this.authGaurdService.favData = data;
    this.router.navigate(['/' + data.nav_page_route]);
    console.log(data.nav_page_route);
  }
}